//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const PROMOTED_POSTS_REACH_ESTIMATE_ACTIONS = {
  CLEAR_PROMOTED_POSTS_REACH_ESTIMATE_STATE: 'CLEAR_PROMOTED_POSTS_REACH_ESTIMATE_STATE',
  REQUEST_REACH_ESTIMATE: 'REQUEST_REACH_ESTIMATE',
  RECEIVE_REACH_ESTIMATE: 'RECEIVE_REACH_ESTIMATE',
};
